import React from 'react';
import { ButtonV2, Link } from '@zola/zola-ui';

import './TourTooltip.less';

const TourTooltip = ({
  continuous,
  index,
  isLastStep,
  step,
  backProps,
  primaryProps,
  skipProps,
  tooltipProps,
  size,
}) => {
  const getButtonText = () => {
    if (!continuous) {
      return 'Close';
    }
    if (!isLastStep) {
      return 'Next';
    }
    if (size === 1) {
      return 'Got It';
    }
    return 'Done';
  };
  return (
    <div className="tour-tooltip" {...tooltipProps}>
      {/* step.title && <h1>{step.title}</h1> */}
      {step.content && <div className="content">{step.content}</div>}
      <div>
        {!isLastStep && (
          <Link {...skipProps} className="skip-tour">
            End Tour
          </Link>
        )}
        <div className="pull-right">
          {step.showProgress && size > 1 && (
            <span className="tour-progress">{`${index + 1} of ${size}`}</span>
          )}
          {index > 0 && !step.hideBackButton && (
            <ButtonV2 variant="secondary" compact {...backProps}>
              Back
            </ButtonV2>
          )}
          <ButtonV2 compact {...primaryProps}>
            {getButtonText()}
          </ButtonV2>
        </div>
      </div>
    </div>
  );
};

export default TourTooltip;



// WEBPACK FOOTER //
// ./src/components/common/ui/Tour/TourTooltip/TourTooltip.jsx